export default class Email {
	/**
	 * Email address string value.
	 * This is needed for react select.
	 * @param {string} value
	 */
	constructor(public readonly value: string, public readonly valid: boolean) {}
}
